/* @flow */

import * as React from 'react';

import { getDisplayName } from '@braindate/util/lib/react/hoc/hocUtil';

type Props = {
  handleMount: () => void,
  handleUnmount: () => void,
};

export default function mount(WrappedComponent: any) {
  const WithMountComponent = (props: Props): React.Node => {
    const { handleMount, handleUnmount } = props;

    /*
     |----------------------------------------------------------------------------
     | Effects
     |----------------------------------------------------------------------------
     */

    React.useEffect(() => {
      if (handleMount) {
        handleMount();
      }

      return () => {
        if (handleUnmount) {
          handleUnmount();
        }
      };
    }, []);

    /*
     |----------------------------------------------------------------------------
     | Elements
     |----------------------------------------------------------------------------
     */

    return <WrappedComponent {...props} />;
  };

  WithMountComponent.displayName = `WithMountComponent(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithMountComponent;
}
